import { MealTracking } from "@/features/shelter/MealTracking";

export function MealTrackingPage() {
  return <MealTracking />;
}
